<div
  class="geolocation-overlay"
  *ngIf="visible$ | async"
  role="status"
  aria-live="polite"
  aria-busy="true"
>
  <div class="geolocation-overlay__frame">
    <div class="gps-icon-wrapper" aria-hidden="true">
      <span class="gps-ripple gps-ripple--1"></span>
      <span class="gps-ripple gps-ripple--2"></span>
      <span class="gps-ripple gps-ripple--3"></span>
      <mat-icon class="gps-icon">my_location</mat-icon>
    </div>
    <h2 class="geolocation-overlay__title">Calculando sua localização</h2>
    <p class="geolocation-overlay__subtitle">Isso pode levar alguns segundos</p>
  </div>
</div>
